import React from "react";
import Section from "../section";
import { useLocation } from "react-router-dom";
import Container from "../container";
import SectionHeading from "../sectionHeading";
import ProductData from "../../../../common/assets/data/products";
import ScrollAnimation from "react-animate-on-scroll";
import RotateImage from "../images/rotateImage";

const SectionLayout = ({ content, classNameName }) => {
  const data = content;
  const product = ProductData.products;
  const location = useLocation();
  const addAllclassNamees = [""];
  addAllclassNamees.push(classNameName);
  return (
    <Section className="bg-white">
      <Container>
        <div className={addAllclassNamees.join(" ")}>
          <div className="lg:grid lg:grid-cols-2 gap-16 items-center mx-auto max-w-screen-xl">
            {data.sideOne.content && (
              <div className={`sm:text-lg ${data.sideOne.order}`}>
                {data.sideOne.content.Heading && (
                 <ScrollAnimation animateIn="animate__bounce">
                     <SectionHeading
                       heading={data.sideOne.content.Heading}
                     />
                   </ScrollAnimation>
                )}
                    <ScrollAnimation animateIn="animate__fadeIn">
                {data.sideOne.content.Text &&
                  data.sideOne.content.Text.map((text,index) => (
                    <p key={index+1} className="mb-4 text-center text-base md:text-lg md:text-left">{text.value}</p>
                  ))}
                  </ScrollAnimation>
              </div>
            )}
            {data.sideTwo && (
              <div class={`${data.sideTwo.order}`}>
                 <ScrollAnimation initiallyVisible animateIn="animate__fadeIn">
                  <RotateImage Imgsrc={data.sideTwo.data.Pics}/>
                {/* <img
                  className="w-full rounded-lg  pointer-events-none"
                  src={data.sideTwo.data.Pics}
                  alt={data.sideTwo.data.Pics}
                /> */}
                 </ScrollAnimation>
              </div>
            )}
          </div>
        </div> 
      </Container>
    </Section>
  );
};

export default SectionLayout;
